const s="/anonymous-diagnostic-reports",o="/body-sites",e="/token/refresh",t="/scoring-systems";export{s as ANONYMOUS_DIAGNOSTIC_REPORTS,o as BODY_SITES,e as REFRESH_TOKEN,t as SCORING_SYSTEMS};
